<ng-container *ngIf="user?.waitlist">

  <div class="waitlist-banner" *ngIf="displayStyle === 'banner'">
    <i class="fas fa-info-circle"></i>
    <span>{{ user?.waitlistMessage || "We're not accepting applications from your area at this time. You can still complete your onboarding steps — we'll reach out as soon as we have shifts available in your area. If this isn't your location, you can update your address in the onboarding steps." }}</span>
  </div>

  <div class="waitlist-card" *ngIf="displayStyle === 'card'">
    <div class="icon-wrap">
      <i class="fas fa-map-marker-alt"></i>
    </div>
    <h2>No shifts in your area yet</h2>
    <p>{{ user?.waitlistMessage || "We're not accepting applications from your area at this time. You can still complete your onboarding steps — we'll reach out as soon as we have shifts available in your area. If this isn't your location, you can update your address in the onboarding steps." }}</p>
    <ion-button *ngIf="!user?.isSignupProcessComplete" class="cta" (click)="continueOnboarding()">
      Continue onboarding <i class="fas fa-arrow-right"></i>
    </ion-button>
  </div>

</ng-container>
